// src/features/dashboard/mocks/teamKpi.mock.ts

import {
  FaUsers,
  FaClock,
  FaChartLine,
  FaExclamationTriangle,
  FaTimes,
} from 'react-icons/fa';

import type {
  TeamKpiItem,
} from '../types/teamKpi.types';

import type {
  DashboardSummaryResponse,
} from '../services/teamKpiApi';

/**
 * =========================================
 * MOCK DATA
 * =========================================
 */
export const teamKpiMockData: DashboardSummaryResponse = {

  teamMembers: 125,

  avgDailyActiveHours: 8.4,

  productivePercentage: 87.5,

  below6HoursDays: 12,

  leaveDays: 5,
};

/**
 * =========================================
 * MAP DATA
 * =========================================
 */
export const getTeamKpiCards = (
  data: DashboardSummaryResponse,
): TeamKpiItem[] => {

  const iconMap = {

    teamMembers:
      FaUsers,

    avgDailyActiveHours:
      FaClock,

    productivePercentage:
      FaChartLine,

    below6HoursDays:
      FaExclamationTriangle,

    leaveDays:
      FaTimes,
  };

  const bgMap = {

    teamMembers:
      'bg-[#E8F1FF]',

    avgDailyActiveHours:
      'bg-[#E9FBF4]',

    productivePercentage:
      'bg-[#F4ECFF]',

    below6HoursDays:
      'bg-[#FFF3E8]',

    leaveDays:
      'bg-[#FFECEC]',
  };

  const colorMap = {

    teamMembers:
      'text-[#3B82F6]',

    avgDailyActiveHours:
      'text-[#10B981]',

    productivePercentage:
      'text-[#7C3AED]',

    below6HoursDays:
      'text-[#F97316]',

    leaveDays:
      'text-[#EF4444]',
  };

  /**
   * =========================================
   * DISPLAY TITLES
   * =========================================
   */
  const titleMap = {

    teamMembers:
      'Team Members',

    avgDailyActiveHours:
      'Avg. Daily Active',

    productivePercentage:
      'Productive %',

    below6HoursDays:
      'Below 6H days',

    leaveDays:
      'Leave Days',
  };

  return Object.entries(
    data,
  ).map(
    (
      [
        key,
        value,
      ],
    ) => {

      const typedKey =
        key as keyof DashboardSummaryResponse;

      return {

        /**
         * DISPLAY TITLE
         *
         * Do not show the raw API/property name.
         */
        title:
          titleMap[
            typedKey
          ],

        /**
         * VALUE
         */
        value:
          String(
            value,
          ),

        /**
         * ICON
         */
        icon:
          iconMap[
            typedKey
          ],

        /**
         * BACKGROUND
         */
        bg:
          bgMap[
            typedKey
          ],

        /**
         * ICON COLOR
         */
        color:
          colorMap[
            typedKey
          ],

        /**
         * SUB TEXT
         */
        sub:
          key ===
          'avgDailyActiveHours'
            ? 'hrs'
            : key ===
              'productivePercentage'
              ? '%'
              : '',
      };
    },
  );
};